export default __webpack_public_path__ + "static/spotify-hero-5c2af4571a1b322e950ca1bdd1d7fb6d.png";